import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './EditorDropDown.css'

class EditorDropDown extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      openOption: false
    }
  }
  handleOptions(e) {
    e.preventDefault()
    let nextStatus = !this.state.openOption
    this.setState({ openOption: nextStatus })
  }
  render() {
    const { optionsContents, handleChange, selectedValue } = this.props
    let options = []
    let optionsLi = []
    for (let i in optionsContents) {
      const { value, label } = optionsContents[i]
      options.push(
        <option value={value} key={`editor-drop-down-option-${i}`}>
          {label}
        </option>
      )
      optionsLi.push(
        <li
          data-option=""
          data-value={value}
          styleName="optionItem"
          key={`editor-drop-down-list-${i}`}
          onClick={() => handleChange(value)}
        >
          {label}
        </li>
      )
    }
    return (
      <div styleName="fieldContainer" onClick={e => this.handleOptions(e, this.state.openOption)}>
        <div styleName="textFieldGroup">
          <span styleName={this.state.openOption ? 'textField focus' : 'textField'}>
            {optionsContents.filter(item => item.value === selectedValue)[0]['label']}
          </span>
          <span styleName="highlight" />
          <span styleName="bar" />
          <div styleName={this.state.openOption ? 'dropDownArrow focus' : 'dropDownArrow'}>
            <span />
          </div>
        </div>

        <div styleName={this.state.openOption ? 'focus dropDownGroup' : 'dropDownGroup'}>
          <ul>{optionsLi}</ul>
        </div>
        <select>{options}</select>
      </div>
    )
  }
}

EditorDropDown.propTypes = {
  optionsContents: PropTypes.array.isRequired,
  handleChange: PropTypes.func,
  selectedValue: PropTypes.number
}

export default EditorDropDown
